import { api } from ".";

const basePath = "/terminal";

export const terminalRegistration = async ({
  companyCode,
  terminalCode,
  name,
  location,
  autoControl,
  maxCrlAgeHours,
}: any) => {
  try {
    const res = await api.post(`${basePath}/registration-start`, {
      companyCode,
      terminalCode,
      name,
      location,
      autoControl,
      maxCrlAgeHours,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getTerminalList = async ({
  pageNumber,
  limit,
  sort,
  name,
  locate,
} : {
  pageNumber?: number;
  limit?: number;
  sort?: string;
  locate?: string;
  name?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (sort !== undefined) params.sort = sort;
    if (name !== undefined) params.name = name;
    if (locate !== undefined) params.locate = locate;

    const res = await api.get(`${basePath}/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteTerminal = async ({ id }: any) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateTerminalById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getLocateList = async () => {
  try {
    const res = await api.get(`${basePath}/locate`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getTerminalSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getTerminalById = async (id?: string) => {
  try {
    const res = await api.get(`${basePath}`, { params: { _id: id } });
    return res;
  } catch (error) {
    return error;
  }
};

// Teşhis telemetrisi: terminalin 60 saniyede bir yayınladığı heap/uptime/reset
// örneklerinin zaman serisi. Tek anlık değer sızıntı ile parçalanmayı ayırt
// etmeye yetmediği için seri halinde çekiliyor.
export const getTerminalTelemetry = async ({
  terminalId,
  hours = 24,
}: {
  terminalId?: string;
  hours?: number;
}) => {
  try {
    const res = await api.get(`${basePath}/telemetry`, {
      params: { terminalId, hours: String(hours) },
    });
    return res;
  } catch (error) {
    return error;
  }
};

// Şirketin tüm terminallerinin SON örneği — tablo durum rozeti için.
export const getTerminalTelemetryLatest = async () => {
  try {
    const res = await api.get(`${basePath}/telemetry/latest`);
    return res;
  } catch (error) {
    return error;
  }
};
